import Styles from "./styles";

export default function BasicButton({ disabled, buttonText, onClick }) {
  return (
    <Styles.Button type="button" onClick={onClick} disabled={disabled}>
      {buttonText}
    </Styles.Button>
  );
}
